<template>
  <div class="container mt-4">
    <h3 class="lesson-subheading">Chances of a random pick given a middle number</h3>
    <hr class="subheading-separator" />
    <div class="row">
      <div class="col-md-6">
        <app-solutions-count :solutions="solutions" :totalCounts="totalCounts"></app-solutions-count>
        <app-cross-table
          :horizontalNumbers="horizontalNumbers"
          :verticalNumbers="verticalNumbers"
          :middleNumber="middleNumber"
          :myMiddleNumber="myMiddleNumber"
          :pickMiddleNumber="pickMiddleNumber"
          @setMiddleNumber="myMiddleNumber=$event"
        ></app-cross-table>
        <div class="mb-3"></div>
        <div
          class="text-center alert alert-success"
        >Please drag one number tile to the middle to test</div>
        <div class="text-center mt-3">
          <div>
            <button
              v-if="demoAutoOption==='0'"
              class="btn btn-outline-success"
              @click="handlePlayOneGame"
              :disabled="!myMiddleNumber"
            >{{ this.crossGame.totalCounts === 0 ? "Tap for random pick" : "Tap for next game" }}</button>
            <button
              v-if="demoAutoOption==='1'"
              class="btn btn-outline-success"
              @click="handleToggleTimer"
              :disabled="!myMiddleNumber"
            >
              {{ totalCounts === 0 ? "Tap to begin auto" :
              timer ? 'Tap here to pause' : 'Tap here to resume'
              }}
            </button>
            <span class="mx-3"></span>
            <button
              class="btn btn-outline-dark"
              @click="handleReset"
              :disabled="!pickMiddleNumber"
            >Reset</button>
          </div>
          <app-demo-auto-option
            @changeOption="demoAutoOption = $event"
            :option="demoAutoOption"
            class="mt-2"
          ></app-demo-auto-option>
        </div>
      </div>
      <div class="col-md-6">
        <app-unique-solutions
          :uniqueSolutionsList="uniqueSolutionsList"
          @selectSolution="handleSelectSolution"
        ></app-unique-solutions>
      </div>
    </div>
  </div>
</template>

<script>
import CrossTable from "./CrossTable";
import SolutionsCount from "./SolutionsCount";
import UniqueSolutions from "./UniqueSolutions";
import DemoAutoOption from "../../common/DemoAutoOption";
import CrossGame from "./crossGame";
export default {
  components: {
    appCrossTable: CrossTable,
    appSolutionsCount: SolutionsCount,
    appUniqueSolutions: UniqueSolutions,
    appDemoAutoOption: DemoAutoOption,
  },
  data: function () {
    return {
      crossGame: null,
      demoAutoOption: "1",
      timer: null,
      myMiddleNumber: 0,
      pickMiddleNumber: true,
    };
  },
  computed: {
    totalCounts() {
      return this.crossGame ? this.crossGame.totalCounts : 0;
    },
    solutions() {
      return this.crossGame ? this.crossGame.solutions : 0;
    },
    uniqueSolutionsList() {
      return this.crossGame ? this.crossGame.uniqueSolutionsList : [];
    },
    horizontalNumbers() {
      return this.crossGame && this.crossGame.horizontalNumbers;
    },
    verticalNumbers() {
      return this.crossGame && this.crossGame.verticalNumbers;
    },
    middleNumber() {
      return this.crossGame && this.crossGame.middleNumber;
    },
  },
  watch: {
    demoAutoOption(value) {
      // console.log(value);
      if (value === "0") {
        this.clearTimer();
      }
    },
    "crossGame.uniqueSolutionsList": function () {
      this.clearTimer();
    },
  },
  methods: {
    handlePlayOneGame() {
      if (!this.myMiddleNumber) return;
      this.pickMiddleNumber = false;
      this.crossGame.playOneGame(this.myMiddleNumber);
      // console.log(this.crossGame);
    },
    handleToggleTimer() {
      if (!this.myMiddleNumber) return;
      this.pickMiddleNumber = false;
      if (this.timer) {
        this.clearTimer();
        return;
      }
      this.timer = setInterval(() => {
        this.crossGame.playOneGame(this.myMiddleNumber);
      }, 50);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleReset() {
      this.myMiddleNumber = 0;
    },
    handleSelectSolution($event) {
      const solution = this.crossGame.uniqueSolutionsList[$event];
      // console.log(this.crossGame.uniqueSolutionsList[$event]);
      this.crossGame.horizontalNumbers = solution[0];
      this.crossGame.verticalNumbers = solution[1];
    },
  },
  created() {
    this.crossGame = new CrossGame();
  },
};
</script>

<style scoped>
</style>